module.exports = __webpack_public_path__ + "media/organizations/DHL-8321517a.webp";